import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FeatureFlag } from '@api-types/types/feature-flag';
import { CoreState } from '@core/store/core.state';

import { AppActivatedRouteSnapshot } from '@core/types/app-activated-route-snapshot.interface';
import { Store } from '@ngrx/store';

export class FeatureGuard {
  static forFeature(
    featureSelector: (state: CoreState) => FeatureFlag,
    redirectRoute = '/access-denied',
  ) {
    @Injectable({ providedIn: 'root' })
    class FeatureCheck implements CanActivate {
      private readonly store = inject(Store);
      protected router = inject(Router);
      private readonly featureFlag = this.store.selectSignal(featureSelector);

      async canActivate(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        activeRoute: AppActivatedRouteSnapshot,
      ): Promise<boolean> {
        const featureFlag = this.featureFlag();
        if (featureFlag.enabled) {
          return true;
        }

        this.router.navigate([redirectRoute]);
        return false;
      }
    }
    return FeatureCheck;
  }
}
